module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cfb9384b0c3ec1f02641f37b34764e84.png";